import { render, staticRenderFns } from "./Notenliste.vue?vue&type=template&id=3f9b7682&"
import script from "./Notenliste.vue?vue&type=script&lang=js&"
export * from "./Notenliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports